<template>
  <div>
    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.street'" rules="required|min:2|address_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_ADDRESS_DETAILS.STREET') + ' *'"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.street"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.number'" rules="address_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_ADDRESS_DETAILS.NUMBER')"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.number"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.city'" rules="required|min:2|address_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_ADDRESS_DETAILS.CITY') + ' *'"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.city"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.zip'" rules="required|min:5|max:5|address_string|zip_string" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_ADDRESS_DETAILS.ZIP') + ' *'"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.zip"
        ></v-text-field>
      </validation-provider>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressDetailsRequired',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    }
  },
  data () {
    return {
      model: {}
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
